
import { IFileUploadDetails } from "@directives/_forms/fileUpload/fileUpload.component";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { IHttpException } from "@interfaces/IHttpException";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { IUser } from "@interfaces/IUser";
import { AccountService } from "@services/account.service";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import "angular-material";
import "./companyImage.scss";



export class CompanyImageController {

    errorMessage: string;

    currentUser: IUser;

    companyImage: string;

    preventDialogFromClosing = false;

    saving: boolean;

    static $inject = ["$rootScope", "$q", "$mdDialog", "accountService", "translationService", "$scope", "accountId"];

    constructor(
        private readonly $rootScope: IRunBlockRootScope,
        private readonly $q: angular.IQService,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly accountService: AccountService,
        private readonly translationService: TranslationService,
        private readonly $scope: angular.IScope,
        private readonly accountId?: number,
       ) {

        this.currentUser = angular.copy($rootScope.currentUser);
    }

    hide() {
        if (!this.preventDialogFromClosing) {
            this.$mdDialog.hide();
        }
    }

    onDriverImageChanged(fileUploadDetails: IFileUploadDetails): void {
        this.$scope.$evalAsync(() => {
            this.companyImage = fileUploadDetails.fileString;
        })

    }

    onFileCleared(): void {
        this.companyImage = "";
    }

    saveChanges() {
        this.saving = true;
        let imagePromise = this.$q.when();

        // Only update image if it has not been set
        if (this.companyImage) {
            imagePromise = this.accountService.setAccountImage(this.companyImage, this.accountId);
        }

        // Wait for all saving events to complete
        this.$q.all([imagePromise])
            .then(() => {
                if (this.companyImage) {
                    this.$rootScope.$broadcast(BroadcastEvent.updateAccountImage);
                }
            })
            .catch((a: angular.IHttpPromiseCallbackArg<IHttpException>) => {

                this.errorMessage = this.translationService.t('companyImage.unableToSave', a.data.ExceptionMessage);
            })
            .finally(() => {
                this.saving = false;
                this.hide();

            });
    }
}
